export default __webpack_public_path__ + "static/media/CNo.33-2.10c35eb7.jpg";